import { JSON_CONTENT } from '@src/utils/ajaxUtils'
import authAjax from '@user/utils/ajaxUtils'
import { objToQueryStr } from '@src/utils/function'

const API_PATH = '/user'

export const getListAjax = (params: Object) =>
  authAjax.get(`${API_PATH}/jump${objToQueryStr(params)}`, JSON_CONTENT)
